/**
 * @Author: 韩祺涛
 * @Date: 2023/4/26
 * @Project: 杭氧客户现场使用
 */
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

// 获取字段表格数据
export function getTableData (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/fields',
    method: 'GET',
    params: parameter
  })
}
// 获取详情
export function getDetail (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/field/detail',
    method: 'GET',
    params: parameter
  })
}
// 获取详情中的表格
export function getDetailTable (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/field/infos',
    method: 'GET',
    params: parameter
  })
}
// 新增/修改字段
export function saveField (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/field',
    method: 'POST',
    data: parameter
  })
}
// 启用
export function startUsing (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/field/startUsing',
    method: 'PUT',
    params: parameter
  })
}
// 禁用
export function forbidden (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/field/forbidden',
    method: 'PUT',
    params: parameter
  })
}
// 禁用校验
export function forbiddenCheck (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/field/forbidden/check',
    method: 'GET',
    params: parameter
  })
}
// 删除
export function delField (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/field',
    method: 'DELETE',
    params: parameter
  })
}
// 删除校验
export function delFieldCheck (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/field/delete/check',
    method: 'GET',
    params: parameter
  })
}
